import { FC } from "react";

import { InnovatricsDocumentTypes } from "../../../../data/innovatricsDocumentTypes";
import { CustomMultiSelect } from "../../../ui/components/CustomMultiSelect";

type InnovatricsDocTypesMultiSelectProps = {
  label?: string;
  name?: string;
  value: string[];
  onChange: (value: string[]) => void;
  [x: string]: any;
};

/**
 * Multi-select for Innovatrics document types. Values and callbacks use `string[]` of type codes.
 */
export const InnovatricsDocTypesMultiSelect: FC<InnovatricsDocTypesMultiSelectProps> = ({
  label = "Document types",
  name = "documentTypes",
  value,
  onChange,
  ...rest
}) => {
  return (
    <CustomMultiSelect
      data={InnovatricsDocumentTypes}
      name={name}
      label={label}
      values={value || []}
      onChange={onChange}
      valueField="type"
      nameField="name"
      {...rest}
    />
  );
};

export { InnovatricsDocTypeSingleSelect } from "./InnovatricsDocTypeSingleSelect";
export default InnovatricsDocTypesMultiSelect;
